import React, { Component } from "react";
import FieldError from "./FieldError";
import "./DropDownInputField.scss";

function getGroupData(data, group, groupKey) {
  return data.filter((item) => item.get(groupKey) === group);
}

class DropDownInputField extends Component {

  render() {
    const {serverError, label, data, valueKey, titleKey, groupKey, showBlank, useGroups, groups} = this.props;
    const {input: {value, onChange}, meta: {touched, error}} = this.props;    

    const emptyOption = <option key="" value=""/>;
    let options = null;
    if (useGroups === true) {
      options = groups.map((group) => {
        return (
          <Group key={group.get("group")} 
                 id="group" 
                 label={group.get("label")} 
                 data={getGroupData(data, group.get("group"), groupKey)}
                 valueKey={valueKey}
                 titleKey={titleKey} />
        );
      })
    } else {
      options = data.map(option => {
        return (
          <option key={option.get(valueKey)} value={option.get(valueKey)}>{option.get(titleKey)}</option>
        )
      })
    }

    const optionsWithEmpty = options.insert(0, emptyOption);

    const useOptions = showBlank ? optionsWithEmpty : options;

    return (
      <tr className="DropDownInputField field">
        <th>{label}</th>
        <td>
          <select
            value={value}
            onChange={onChange}>
            {useOptions}
          </select>
          <FieldError serverError={serverError} clientError={error} showClientError={touched && error} />
        </td>
      </tr>
    )
  }

  renderErrors() {
    // const {meta: {touched, error}} = this.props;
    const {error, meta: {touched}} = this.props;
    if (touched && error) {
      return <div className="fieldError">{error}</div>
    }
    return null;
  }
}

const Group = (props) => {
  let options = props.data.map(option => {
    return (
      <option key={option.get(props.valueKey)} value={option.get(props.valueKey)}>{option.get(props.titleKey)}</option>
    )
  });

  return (
    <optgroup label={props.label}>
      {options}
    </optgroup>
  )
}


DropDownInputField.defaultProps = {
  showBlank: true,
  useGroups: false,
  groupKey: "group",
  valueKey: "value",
  titleKey: "title",
}

export default DropDownInputField;